<script>
export default {
    data() {
        return {
            loading: false,
            visible: false,
            processing: false,
            data: []
        }
    },
    created() {
        this.getItems()
    },
    methods: {
        getItems() {
            this.loading = true

            this.$http
                .get(this.routeUri('api.messages.create'))
                .then(response => (this.data = response.data))
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
        handleSelect(id, name) {
            this.$emit("handleSelect", id, name)
        },
        handleClose() {
            this.$emit("handleClose", false)
        },
    }
}
</script>

<template>
    <div>
        <a-skeleton :loading="loading">
            <a-list bordered :data-source="data">
                <a-list-item slot="renderItem" slot-scope="item">
                    <a-button
                        slot="actions"
                        @click="handleSelect(item.hash, item.name)"
                        :loading="processing"
                        :disabled="processing"
                    ><a-icon type="message" /></a-button>
                     {{ item.name }}
                </a-list-item>
            </a-list>
            <br>
            <a-row type="flex" justify="end">
                <a-col>
                    <a-button
                        @click="handleClose"
                        :loading="processing"
                        :disabled="processing"
                        style="margin-left: 24px"
                        >Tutup</a-button>
                </a-col>
            </a-row>
        </a-skeleton>
    </div>
</template>
